export function tab() {
    let tabsHolder;
    const tabButtons = $(".tabset button, .tabset .tabset-btn-text");
    const classActive = "active";
    let toggleScroll = function (container) {
        if (!container.hasClass("scroll-left")) {
            container.animate({scrollLeft:"+=300"},500);
            container.addClass("scroll-left");
        } else {
            container.animate({scrollLeft:"-=300"},500);
            container.removeClass("scroll-left");
        }
    };

    tabButtons.on("click", function (e) {
        e.preventDefault();

        if (!$(this).hasClass(classActive)) {
            const activeTab = $(this).data("tab");
            $(this).siblings().removeClass(classActive);
            const parentContainer = $(this).closest(".tabs-section");
            const tabs = $(parentContainer).find(".tabs");
            let tabsHolder = $(this).closest(".text-col-view");

            toggleScroll(tabsHolder);

            $(tabs).slideUp(500, function (){
                $(tabs).find(".tab").removeClass(classActive);
                const activeElement = $(`[data-tab="${activeTab}"]`);
                activeElement.addClass(classActive);
            }).slideDown(500);
        }
    });
}


// WEBPACK FOOTER //
// ./assets/js/modules/tab.js